// extracted by mini-css-extract-plugin
export default {"section":"SettingsSection-module__section--lHl+e","header":"SettingsSection-module__header--+Lj4T"};